<template>
  <div class="container-fluid">
    <div class="col s6">
      <div class="row">
        <div class="col s12">
          <div class="section">
            <h5>Dashboard settings</h5>
          </div>
        </div>

        <div class="input-field col s12">
          <select v-model=user.DashboardId>
            <option v-for="dashboard in dashboards"
              v-bind:key="dashboard.ID"
              :value="dashboard.ID">
                {{ dashboard.Name }}
            </option>
          </select>
          <label>Default dashboard</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['currentUser', 'user', 'dashboards']
}
</script>

<style scoped>
p {
margin-top: 12px;
margin-bottom: 12px;
}

.inline-icon {
    vertical-align: bottom;
}

/* BUTTON */
.btn-floating:hover {
background-color: #F39810;
}

.btn:hover, .btn-large:hover, .btn-small:hover {
background-color: #F39810;
}

.btn, .btn-large, .btn-small {
background-color: #56CCF2;
}

[type="checkbox"]:indeterminate+span:not(.lever):before {
border-right: 2px solid #56CCF2;
}
</style>



// WEBPACK FOOTER //
// src/pages/users/_Dashboard.vue